// extracted by mini-css-extract-plugin
export default {"popup-header-empty":"PopupHeaderEmpty_popup-header-empty__xEGnv","close-button":"PopupHeaderEmpty_close-button__n3Tj8"};